module.exports = __webpack_public_path__ + "img/platform.bb16c815.webp";